// dls
import { BaseTheme } from '@swiggy-private/dls-web-common/dist/components/themes/Base';
const DlsLightThemeColorTokens = Object.keys(BaseTheme.colors.light).reduce((acc, curr) => {
    return Object.assign(Object.assign({}, acc), { [curr]: curr });
}, {});
const DlsDarkThemeColorTokens = Object.keys(BaseTheme.colors.dark).reduce((acc, curr) => {
    return Object.assign(Object.assign({}, acc), { [curr]: curr });
}, {});
export const DlsColorTokens = Object.assign({}, DlsDarkThemeColorTokens, DlsLightThemeColorTokens);
export const DlsFontVariants = Object.keys(BaseTheme.typography).reduce((acc, curr) => {
    return Object.assign(Object.assign({}, acc), { [curr]: curr });
}, {});
